// ### IMPORTS GENERAL FOR COMPONENT
/* eslint-disable */
// import basics
import React from 'react'
import PropTypes from 'prop-types'

// import Material UI
import {
  Drawer,
  Typography,
  Tooltip,
  TextField,
  IconButton
} from '@material-ui/core'
import { Save, Check, Close } from '@material-ui/icons'
import { ThreeDots } from 'react-loader-spinner'
// import internal components
import GridItem from 'components/Grid/GridItem'
import GridContainer from 'components/Grid/GridContainer'

// ### ONE PAGE | COMPONENT: DRAWER APPROVALS
const OnePageDrawerApprovals = ({
  isOpen,
  onClose,
  onSave,
  selectedApproval,
  setSelectedApproval,
  approveComment,
  setApproveComment,
  t,
  classes,
  isSaving
}) => {
  return (
    <Drawer
      anchor='bottom'
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        style: {
          height: '35vh',
          borderRadius: '7px',
          padding: '3px 10px 10px 10px',
          margin: '0vh 1vh 1vh 1vh',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      <GridItem
        style={{
          zIndex: 1000,
          position: 'absolute',
          right: '20px',
          top: '20px',
          color: '#3C4858'
        }}
      >
        <Tooltip title={t('initiative_selected.save')}>
          <span>
            <IconButton onClick={onSave} disabled={isSaving}>
              {isSaving ? (
                <ThreeDots color='#3C4858' height={20} width={20} />
              ) : (
                <Save style={{ cursor: 'pointer', fontSize: '20px' }} />
              )}
            </IconButton>
          </span>
        </Tooltip>
      </GridItem>

      <div
        style={{
          flex: 1,
          padding: '8px',
          fontSize: '0.9rem',
          transformOrigin: 'top center'
        }}
        className={classes.drawerContent}
      >
        <GridContainer style={{ marginTop: '10px' }}>
          <GridItem
            xs={12}
            md={12}
            style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
          >
            <Typography
              variant='body1'
              style={{
                color: '#555',
                fontWeight: 500,
                marginRight: '15px'
              }}
            >
              {t('initiative_selected.one_page_comments_title')}
            </Typography>

            <Tooltip title={t('initiative_selected.one_page_approve')}>
              <Check
                className={classes.iconButtonCustom}
                style={{
                  cursor: 'pointer',
                  fontSize: '25px',
                  color: '#388e3c',
                  border:
                    selectedApproval === 'approved'
                      ? '2px solid #388e3c'
                      : 'none',
                  borderRadius: '50%',
                  padding: '2px'
                }}
                onClick={() => setSelectedApproval('approved')}
                disabled={isSaving}
              />
            </Tooltip>

            <Tooltip title={t('initiative_selected.one_page_disapprove')}>
              <Close
                className={classes.iconButtonCustom}
                style={{
                  cursor: 'pointer',
                  fontSize: '25px',
                  color: '#d32f2f',
                  border:
                    selectedApproval === 'disapproved'
                      ? '2px solid #d32f2f'
                      : 'none',
                  borderRadius: '50%',
                  padding: '2px'
                }}
                onClick={() => setSelectedApproval('disapproved')}
                disabled={isSaving}
              />
            </Tooltip>
          </GridItem>

          <GridItem xs={12} md={12} style={{ marginTop: '20px' }}>
            <TextField
              label={t('initiative_selected.one_page_comment_body')}
              multiline
              rows={2}
              variant='outlined'
              fullWidth
              placeholder={t('initiative_selected.one_page_enter_comment')}
              value={approveComment}
              onChange={e => setApproveComment(e.target.value)}
              helperText={`${approveComment.length}/100`}
              classes={{ root: classes.textFieldRoot }}
              InputProps={{
                classes: {
                  input: classes.inputText,
                  root: classes.outlinedInput
                },
                style: { fontSize: '12px' },
                inputProps: { maxLength: 100 }
              }}
              InputLabelProps={{
                classes: { root: classes.labelText },
                shrink: true,
                style: {
                  backgroundColor: '#fff',
                  zIndex: 150,
                  padding: '0px 10px',
                  fontWeight: '700',
                  textTransform: 'uppercase'
                }
              }}
            />
          </GridItem>
        </GridContainer>
      </div>
    </Drawer>
  )
}

// ### PROPS TYPE VALIDATION AND EXPORT DEFAULT
OnePageDrawerApprovals.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  selectedApproval: PropTypes.string,
  setSelectedApproval: PropTypes.func.isRequired,
  approveComment: PropTypes.string.isRequired,
  setApproveComment: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  isSaving: PropTypes.func.isRequired
}

export default OnePageDrawerApprovals
